import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { AiAssistantI18nModule } from '../../../../../assets/i18n/ai-assistant-i18n.module';

@Component({
  selector: 'ai-raven-information-dialog',
  imports: [CommonModule, MatDialogModule, MatButtonModule, AiAssistantI18nModule, TranslateModule],
  templateUrl: './raven-information-dialog.component.html',
})
export class RavenInformationDialogComponent {}
